import css from 'styled-jsx/css';
import React from 'react';
// TODO: Migrate module so that you don't import from the corp project in a global module
/* eslint-disable restrict-imports/restrict-imports */
import SectionTitle from 'corp/components/UI/SectionTitle';
import { Section } from 'react-scale/containers/corp/backfills/batch/components/Section';
import WorkerTeamAssignment from 'react-scale/corp/components/Bulbasaur/Language/WorkerTeamAssignment';
import { IUserJson } from '@scale/shared/types/user';
import FixWorkerLanguage from '../components/Bulbasaur/Language/FixWorkerLanguage';

const style = css`
  .root .two-columns {
    display: flex;
  }
  .root .two-columns section {
    flex-basis: 50%;
  }
  .root .two-columns section.disabled {
    color: rgba(0, 0, 0, 0.3);
  }
  .root .three-columns {
    display: flex;
  }
  .root .three-columns section {
    flex-basis: 33%;
  }
  .root .three-columns section.disabled {
    color: rgba(0, 0, 0, 0.3);
  }
  .root .disallowed-task-types {
    font-weight: bold;
    color: red;
  }
  .root .warning {
    font-weight: bold;
    color: red;
  }
  .root.disabled section {
    color: rgba(0, 0, 0, 0.3);
  }
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const BatchActions: React.FC<{ user: IUserJson }> = ({ user }) => {
  return (
    <div className="root">
      <SectionTitle title="🍃 Bulbasaur Utils" />
      <Section name={'Worker Team Assignment'} forceHidden={true}>
        <WorkerTeamAssignment />
      </Section>
      <Section name={'Fix Worker Training Attempt Language'} forceHidden={true}>
        <FixWorkerLanguage />
      </Section>
      <style jsx>{style}</style>
    </div>
  );
};

export default BatchActions;
